<template>
  <v-app id="keep">
    <img src="@/assets/peritos_banner_gr.jpg"  class="hidden-sm-and-down" style="width:100%;height:auto">
    <img src="@/assets/peritos_banner_ch.jpg" class="hidden-md-and-up" style="width:100%;height:auto">
    <div>
      <v-app-bar
        color="#373736"
        dense
        dark
      >
        <v-toolbar-title>
        </v-toolbar-title>
        <v-app-bar-nav-icon  @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-btn icon v-if="isLoggedIn && currentUser.roles[0].id == 3" to="/initial">
          <v-icon>mdi-home</v-icon>
        </v-btn>
        <v-btn icon v-if="isLoggedIn && currentUser.roles[0].id != 3" to="/peritos">
          <v-icon>mdi-microsoft</v-icon>
        </v-btn>
        <div class="text-center" v-if="isLoggedIn && currentUser.roles[0].id != 3">
          <v-menu
             open-on-hover
             offset-y
           >
             <template v-slot:activator="{ on, attrs }">
               <v-btn
                 v-bind="attrs"
                 v-on="on"
               >
                 REPORTES
               </v-btn>
             </template>

             <v-list>
               <v-list-item to="/reporte/refrendos" class="caption">
                 <b>REFRENDOS</b>
               </v-list-item>
               <v-list-item to="/reporte/informes" class="caption">
                 <b>DICTÁMENES</b>
               </v-list-item>
             </v-list>
           </v-menu>
         </div>
         <!-- <div class="text-center"> -->
           <v-btn
             class="ml-2"
             to="/extemporaneo"
             v-if="isLoggedIn && currentUser.roles[0].id == 1"
           >EXTEMPORÁNEOS</v-btn>
          <!-- </div> -->
        <v-spacer></v-spacer>

        <v-btn class="mr-2" color="teal" small href="https://cjj.gob.mx/pages/transparencia/peritos" target="_blank">
          CONVOCATORIA 2024-2025
        </v-btn>
        <v-btn icon v-if="isLoggedIn" @click="logout">
          <v-icon>mdi-lock</v-icon>
        </v-btn>
      </v-app-bar>
    </div>

    <v-navigation-drawer
      v-if="isLoggedIn"
      v-model="drawer"
      app
      color="grey lighten-4"
      temporary
    >

    <v-list-item>
      <v-list-item-icon>
        <v-icon>mdi-account</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="title text-wrap" v-if="roleUser === 1 || roleUser === 2">{{ currentUser.nombre.toUpperCase() }}</v-list-item-title>
        <v-list-item-title class="title text-wrap" v-else>{{currentUser.nombre}} {{currentUser.primer_apellido}} {{currentUser.segundo_apellido}}</v-list-item-title>
        <div align="right" class="mt-1">
        <v-btn x-small color="primary" dark to="/updatepassword">Cambiar Contraseña</v-btn>
      </div>
      </v-list-item-content>

      </v-list-item>


      <v-divider></v-divider>

      <v-list v-if="roleUser === 1" dense class="grey lighten-4">
        <template v-for="(item, i) in itemsAdmin">
          <v-row v-if="item.heading" :key="i" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
          </v-row>
          <v-divider v-else-if="item.divider" :key="i" dark class="my-4"></v-divider>
          <v-list-item v-else :key="i" :to="item.link">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <v-list v-if="roleUser === 2" dense class="grey lighten-4">
        <template v-for="(item, i) in itemsAdminPerito">
          <v-row v-if="item.heading" :key="i" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
          </v-row>
          <v-divider v-else-if="item.divider" :key="i" dark class="my-4"></v-divider>
          <v-list-item v-else :key="i" :to="item.link">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <v-list v-if="roleUser === 3" dense class="grey lighten-4">
        <template v-for="(item, i) in itemsPerito">
          <v-row v-if="item.heading" :key="i" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
          </v-row>
          <v-divider v-else-if="item.divider" :key="i" dark class="my-4"></v-divider>
          <v-list-item v-else :key="i" :to="item.link">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <v-list v-if="roleUser === 4" dense class="grey lighten-4">
        <template v-for="(item, i) in itemsVisor">
          <v-row v-if="item.heading" :key="i" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
          </v-row>
          <v-divider v-else-if="item.divider" :key="i" dark class="my-4"></v-divider>
          <v-list-item v-else :key="i" :to="item.link">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="logout" block color="grey darken-3 white--text">
            Cerrar Sesión
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <template>
      <v-card flat>
        <v-footer
        color="#FFFFFF"
        padles
        >
          <v-col
            class="text-center"
            cols="12"
          >
            <strong style="color: green">Consejo de la Judicatura del Estado de Jalisco. - {{ new Date().getFullYear() }}</strong>
          </v-col>
        </v-footer>
      </v-card>
    </template>

  </v-app>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: false,
      itemsAdmin: [
        { heading: 'Usuarios' },
        { icon: "mdi-account", text: "Usuarios", link: "/users" },
        { icon: "mdi-account-question", text: "Roles", link: "/roles" },
        { icon: "mdi-key", text: "Permisos", link: "/permisos" },
        { icon: "mdi-clipboard-text-outline", text: "Especialidades", link: "/especialidades" },
        { icon: "mdi-gavel", text: "Juzgados", link: "/juzgados" },
        { divider: true },
        { icon: 'mdi-account-group', text: 'Peritos',  link: "/peritos" },
        { icon: 'mdi-file-outline', text: 'Reporte de Refrendos',  link: "/reporte/refrendos" },
      ],
      itemsAdminPerito: [
        { heading: 'Usuarios' },
        { icon: "mdi-account", text: "Usuarios", link: "/users" },
        // { icon: "mdi-clipboard-text-outline", text: "Especialidades", link: "/especialidades" },
        // { icon: "mdi-gavel", text: "Juzgados", link: "/juzgados" },
        { heading: 'Peritos' },
        { icon: 'mdi-account-group', text: 'Peritos',  link: "/peritos" },
        { icon: "mdi-clipboard-text-outline", text: "Especialidades", link: "/especialidades" },
        {heading: 'Catálogos' },
        { icon: "mdi-gavel", text: "Juzgados", link: "/juzgados" },
      ],
      itemsPerito: [
        { heading: 'Solicitudes' },
        { icon: 'mdi-pencil-box-outline', text: 'Datos Personales',  link: "/perito/show" },
        { icon: 'mdi-folder-outline', text: 'Informes',  link: "/informes" },
      ],
      itemsVisor: [
        { heading: 'Peritos' },
        { icon: 'mdi-account-group', text: 'Peritos',  link: "/peritos" },
      ],
    }),
    computed: {
      ...mapGetters(["roleUser", "isLoggedIn", "currentUser", 'permisosList'])
    },
    methods: {
      logout() {
        this.$store
          .dispatch("LOGOUT")
          .then(() => {
            this.$swal({
              title: "Ha cerrado Sesión",
              icon: "success",
              timer: 1000
            }).then(() => {

            });
              //this.$router.go('/');
             this.$router.push("/");
          })
          .catch(error => {
            this.$swal({
              title: "Error",
              text: "No se pudo Cerrar la Sesión Correctamente",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
      }
    }
  }
</script>

<style>
#keep .v-navigation-drawer__border {
  display: none
}
</style>
